import './StrapSelectTool.less';
import React, {useState, useEffect} from 'react';
import StrapCandidateSelector from '../../widgets/strap-candidate-selector/StrapCandidateSelector';
import WatchStrapViewer from '../../widgets/watch-strap-viewer/WatchStrapViewer';
import ProductToolControlBlock from '../../widgets/product-tool-control-block/ProductToolControlBlock';
import __ from '../../../i18n';
import ProductBasicInfoTable from '../../widgets/product-basic-info-table/ProductBasicInfoTable';
import {
    REFERENCE_KEY_STRAP_BUCKLE_MATERIAL,
    REFERENCE_KEY_STRAP_BUCKLE_SIZE,
    REFERENCE_KEY_STRAP_BUCKLE_TYPE,
    REFERENCE_KEY_STRAP_MATERIAL,
    REFERENCE_KEY_STRAP_WIDTH
} from '../../../model-constants/product-attribute-group/referenceKeys';
import {TYPE_STRAP} from '../../../model-constants/product-class/types';
import ProductStrapCandidateListParcel from '../../endpoints/product-strap-candidate/ProductStrapCandidateListParcel';
import ProductToolMessageBox from '../../widgets/product-tool-message-box/ProductToolMessageBox';
import ZoomController from "../../widgets/zoom-controller/ZoomController";
import ProductExtraBadge from "../../widgets/product-extra-badge/ProductExtraBadge";
import ProductExtraOrderBlock from "../../widgets/product-extra-order-block/ProductExtraOrderBlock";


export default function StrapSelectTool({
    initialSelectedOption = null,
    onExposeSetSelectedOption = () => {},
    watchCandidates = null,
    specificWatchCandidate = null,
    recommendedStrapCandidates = [],
    images,
    cartHandler,
    onManualActionEnd = () => {},
    onChangeProductStrapCandidate = () => {},
    defaultSelectedStrapCandidate = null,
}) {

    const [storedImages, setStoredImages] = useState(images);

    const [selectedStrapCandidate, setSelectedStrapCandidate] = useState(defaultSelectedStrapCandidate || recommendedStrapCandidates[0] || null);

    const [selectedProductStrapCandidate, setSelectedProductStrapCandidate] = useState(null);

    useEffect(() => {
        if (defaultSelectedStrapCandidate !== null) {
            setSelectedStrapCandidate(defaultSelectedStrapCandidate);
        }
    }, [defaultSelectedStrapCandidate]);

    const [selectedOption, setSelectedOption] = useState(initialSelectedOption);

    useEffect(() => {
        onExposeSetSelectedOption(setSelectedOption);
    }, []);

    const storeImages = (images) => {
        const newImages = images.filter(t => !storedImages.map(m => m.id).includes(t.id));
        if (newImages.length > 0) {
            setStoredImages(storedImages.concat(newImages));
        }
    };

    const onProductStrapCandidateChange = (productCandidate, productCandidateImages) => {
        storeImages(productCandidateImages);

        setSelectedProductStrapCandidate(productCandidate);

        // because: ProductCandidate <=> Product + Candidate
        setSelectedStrapCandidate(productCandidate);

        onChangeProductStrapCandidate(productCandidate, productCandidateImages);
    };

    const [zoomScale, setZoomScale] = useState(1.05);

    const [isNotEnoughData, setIsNotEnoughData] = useState(false);

    const watchCandidate = specificWatchCandidate || watchCandidates.find(t =>
        t.product_option_id === (selectedOption ? selectedOption.id : null)
    );

    const StrapWidthsFixed_ProductStrapCandidateListParcel = class extends ProductStrapCandidateListParcel {
        constructor(filters = {}, orders, page, pageSize) {

            filters.strapWidths = [watchCandidate.lug_width];
            super(filters, orders, page, pageSize);
        }
    }

    if (!watchCandidate) {
        return <div className="strap-select-tool">
            <div className="message-area">
                <ProductToolMessageBox>
                    {
                        selectedOption
                            ? <p>{__('There is no preview for option :option of this watch', {option: selectedOption.name})}</p>
                            : <p>{__('There is no preview for this watch')}</p>
                    }
                    <p>{__('Please choose another option to see preview')}</p>
                </ProductToolMessageBox>
            </div>
        </div>;
    }

    if (isNotEnoughData) {
        return <div className="strap-select-tool">
            <div className="message-area">
                <ProductToolMessageBox message={__('There is not enough data to display')}/>
            </div>
        </div>;
    }

    return <div className="strap-select-tool">
        <div className="viewer-wrapper">
            {
                watchCandidate &&
                selectedStrapCandidate &&
                <>
                    <WatchStrapViewer
                        watchCandidate={watchCandidate}
                        strapCandidate={selectedStrapCandidate}
                        images={storedImages}
                        zoomScale={zoomScale}
                    />
                    <ZoomController
                        defaultValue={zoomScale}
                        onChange={setZoomScale}
                        max={4}
                        min={0.5}
                    />
                    {
                        selectedStrapCandidate.strap_width !== watchCandidate.lug_width &&
                        <div className="message-area">
                            <ProductToolMessageBox
                                message={__('The width of the strap you are selecting is :strapWidth[mm] not match the lug width of this watch is :lugWidth[mm]', {
                                    strapWidth: selectedStrapCandidate.strap_width,
                                    lugWidth: watchCandidate.lug_width
                                })}
                            />
                        </div>
                    }
                </>
            }
        </div>
        <div className="control-panel">
            {
                (selectedStrapCandidate || recommendedStrapCandidates.length === 0) &&
                <ProductExtraBadge
                    initialExtraId={selectedStrapCandidate ? selectedStrapCandidate.id : null}
                    productClassType={TYPE_STRAP}
                    ProductExtraListParcel={StrapWidthsFixed_ProductStrapCandidateListParcel}
                    browseButtonText={__('Select another strap')}
                    browseToolTitle={__('Select your strap')}
                    onBrowsingEnd={onManualActionEnd}
                    onChange={onProductStrapCandidateChange}
                    onLoadedEmpty={() => {
                        setSelectedProductStrapCandidate(null);

                        if (recommendedStrapCandidates.length === 0) {
                            setIsNotEnoughData(true);
                        }
                    }}
                />
            }
            {
                recommendedStrapCandidates.length > 0 &&
                <ProductToolControlBlock
                    title={__('Recommended straps')}
                >
                    <StrapCandidateSelector
                        strapCandidates={recommendedStrapCandidates}
                        images={storedImages}
                        defaultSelectedStrapCandidateId={selectedStrapCandidate !== null ? selectedStrapCandidate.id : null}
                        onSelectedStrapCandidateIdChange={(selectedId) => {
                            onManualActionEnd();
                            setSelectedStrapCandidate(recommendedStrapCandidates.find(t => t.id === selectedId));
                        }}
                    />
                </ProductToolControlBlock>
            }
            {
                selectedProductStrapCandidate &&
                <ProductToolControlBlock
                    title={__('Basic information')}
                >
                    <ProductBasicInfoTable
                        productCategoryId={selectedProductStrapCandidate.category_id}
                        productId={selectedProductStrapCandidate.product_id}
                        overwrittenAttributes={{
                            [REFERENCE_KEY_STRAP_WIDTH]: __(':size[mm]', {size: selectedProductStrapCandidate.strap_width})
                        }}
                        referenceKeys={[
                            REFERENCE_KEY_STRAP_WIDTH,
                            REFERENCE_KEY_STRAP_MATERIAL,
                            REFERENCE_KEY_STRAP_BUCKLE_TYPE,
                            REFERENCE_KEY_STRAP_BUCKLE_MATERIAL,
                            REFERENCE_KEY_STRAP_BUCKLE_SIZE,
                        ]}
                    />
                </ProductToolControlBlock>
            }
            {
                selectedProductStrapCandidate &&
                <ProductExtraOrderBlock
                    buttonText={__('Add strap to cart')}
                    productExtra={selectedProductStrapCandidate}
                    images={storedImages}
                    cartHandler={cartHandler}
                />
            }
        </div>
    </div>;
}

